/**
 * Page parts module
 */
import React from 'react';

// App components importation
import { VERSION, RELEASE } from "../../config";

/**
 * Represents a common page footer
 */
export function Footer() {
    return (
        <div className="w3-padding-32">
            <hr className="w3-margin w3-border-top w3-border-grey" />

            <div className="w3-right w3-tiny w3-text-grey w3-margin-right">
                &#169; {new Date(RELEASE).getFullYear()} - <b>Auditum Service Hub</b> <a href="#/about"
                    target="_blank" title="About the project">
                    version {VERSION} {RELEASE}
                </a>
            </div>
        </div>
    );
}
